<div class="contactus-modal">
  <p class="contactus-modal__introduction" *ngIf="contactData.formIntroduction">
    {{ contactData.formIntroduction }}
  </p>

  <form [formGroup]="validateForm" (ngSubmit)="submit()" class="contactus-modal__form">
    <div class="contactus-modal__field" *ngFor="let item of forms">
      <label class="contactus-modal__label"
        [class.contactus-modal__label--required]="item.options && item.options.required"
        *ngIf="getFormItemLabel(item)">
        {{ getFormItemLabel(item) }}
      </label>
      <ng-container [ngSwitch]="item.type">
        <input *ngSwitchCase="'input'" nz-input [formControlName]="item.key"
          [placeholder]="item.options?.formPlaceholder || ''" maxlength="100" />
        <textarea *ngSwitchCase="'textarea'" nz-input [formControlName]="item.key"
          [placeholder]="item.options?.formPlaceholder || ''" maxlength="1000"></textarea>
        <nz-select *ngSwitchCase="'select'" class="contactus-modal__control" [formControlName]="item.key"
          [nzMode]="item.options?.multiple ? 'multiple' : 'default'"
          [nzPlaceHolder]="item.options?.formPlaceholder || ''">
          <nz-option *ngFor="let option of item.data || []" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
        <nz-radio-group *ngSwitchCase="'radio'" [formControlName]="item.key">
          <label nz-radio *ngFor="let option of item.data || []" [nzValue]="option.value">
            {{ option.label }}
          </label>
        </nz-radio-group>
        <app-form-file-select *ngSwitchCase="'upload'" [formControlName]="item.key"
          [accept]="item.options && item.options.fileType !== undefined ? item.options.fileType : 'jpg,jpeg,png'"
          [fileSize]="item.options && item.options.fileSize !== undefined ? item.options.fileSize : 30"
          [limit]="item.options && item.options.fileCount !== undefined ? item.options.fileCount : 1">
        </app-form-file-select>
      </ng-container>
    </div>
  </form>

  <p class="contactus-modal__consent" *ngIf="contactData.formInformedConsent">
    <label nz-checkbox [(ngModel)]="consentAccepted" [ngModelOptions]="{standalone: true}">
      {{ contactData.formInformedConsent }}
    </label>
  </p>
</div>
